(function() {
    angular
        .module("loginModule", [
            "ui.router"
        ])
})()
